import { TranslatorService } from './../../../core/services/translator/translator.service';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

import { Fund } from '@app/core/models/fund.model';
import { CaceisIcons } from '@app/custom-shared/components/icons/caceis-icon/caceis-icon.component';
import { MasterAssociarFundosService } from './master-consulta-fundos.service';
import { InvestmentGroups } from './master-associar-fundos.models';
import { take } from 'rxjs/operators';
import { MasterConfirmedMessageComponent } from '../confirmed-message/master-confirmed-message.component';
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { ConfirmBoxColor } from '@app/custom-shared/components/alerts/confirm-box/confirm-box.component';
import { PermissionsType } from '@app/custom-shared/enums/permissions-type.enum';
import { HtmlTagDefinition } from '@angular/compiler';
import { AppAutoCompleteComponent } from '@app/custom-shared/components/form/app-auto-complete/app-auto-complete.component';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
const BASE_PATH = environment.basePath;

interface AppAutoCompleteModel {
  label: string;
  value: any;
};

/**
 * This Component manages the presentation logic of Edit screen
 *
 */
@Component({
  selector: 'app-master-associar-fundos',
  templateUrl: './master-associar-fundos.component.html',
  styleUrls: ['./master-associar-fundos.scss'],
})
export class MasterAssociarFundosComponent extends AppScreenBase
  implements OnInit {
  vars: any = {};
  loading$: Observable<boolean>;
  data$: Observable<any>;
  startColumn = 'desc';
  fundsSorted: boolean = false;

  code: string;
  name: string;

  users: any;
  displayedColumns: string[] = ['name', 'group', 'permissionGroup', 'status'];
  sorted: boolean = false;
  filterAutoComplete: Array<any>;
  dialogConfig: any;
  fixedIncome: MatTableDataSource<Fund>;
  topProfitability: MatTableDataSource<Fund>;
  fund: any;
  permissions: any;
  allUsers: Array<any> = [];

  investmentGroups: MatTableDataSource<InvestmentGroups>;
  groupFilter: any;
  investmentGroupsComplete: any;
  selectedGroups: any;
  investmentGroupsCompleteFiltred: Array<AppAutoCompleteModel>;
  usersCompleteFiltred: Array<AppAutoCompleteModel>;
  investmentGroupSelected: string = '';
  userSelected: string = '';

  groups: any;

  caceisIcons = CaceisIcons;

  openedAutoComplete: boolean = false;

  modalElement: HTMLElement;

  @ViewChild('sortUsers', { static: false }) sortUsers: MatSort;

  @ViewChild('sortGroups', { static: false }) sortGroups: MatSort;

  usersFilter: any;
  usersComplete: any;
  /**
   * Default Constructor of the component
   */
  constructor(
    private associarFundosService: MasterAssociarFundosService,
    public dialogRef: MatDialogRef<MasterAssociarFundosComponent>,
    private dialog: MatDialog,
    private translatorService:TranslatorService,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    super();
    this.code = data.code;
    this.name = data.name;
  }

  ngOnInit() {
    this.getFunds();
    this.setPermissions();

    this.modalElement = AppAutoCompleteComponent.getHtmlElement('.mat-dialog-container');
  }

  setStartColumn(column: string) {
    this.fundsSorted = !this.fundsSorted;

    this.users.data = this.users.data.sort((a, b) => {

      switch (column) {
        case 'name': return this.compare(a.name.naturalNormalize(), b.name.naturalNormalize(), this.fundsSorted);
        case 'group': return this.compare(a.group.naturalNormalize(), b.group.naturalNormalize(), this.fundsSorted);
        case 'permissionGroup': return this.compare(a.permissionGroup.naturalNormalize(), b.permissionGroup.naturalNormalize(), this.fundsSorted);
        case 'status': return this.compare(a.status.naturalNormalize(), b.status.naturalNormalize(), this.fundsSorted);
        default: return 0;
      }
    })
  }

  compare(a, b, isAsc) {
    if (a === null) {
      a = '';
    }

    if (b === null) {
      b = '';
    }
    return (a.toLowerCase().localeCompare(b.toLowerCase()) ? 1 : -1) * (isAsc ? 1 : -1);
  }

  setPermissions() {
    this.permissions = [PermissionsType['editarFundo']];
  }
  onClose(): void { }

  doFechar() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '191px';
    dialogConfig.width = '70vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.id = 'confirm-box-create-user';

    this.dialog
      .open(MasterConfirmedMessageComponent, dialogConfig)
      .afterClosed()
      .subscribe(result => {
        if (result == true) {
          this.dialogRef.close();
        }
      });
  }

  filterGroups(event: Event) {
    this.investmentGroups.filterPredicate = (data, filter) => {
      if (data.id === null || data.id === undefined) {
        data.id = '';
      }
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return (
        data.id.toLowerCase().includes(filter.toLowerCase()) ||
        data.name.toLowerCase().includes(filter.toLowerCase())
      );
    };
    this.groupFilter = (event.target as HTMLInputElement).value;
    this.investmentGroups.filter = this.groupFilter;

    if (this.groupFilter.length > 0 && this.groupFilter.length % 2 == 0) {
      this.investmentGroupsComplete = this.investmentGroups.filteredData.naturalSort(
        ['name'],
      );
    } else if (this.groupFilter.length == 0) {
      this.investmentGroupsComplete = this.investmentGroups.data.naturalSort([
        'name',
      ]);
    }
  }

  setGroups(groups) {
    this.groups = groups;
  }

  onInvestmentGroupSelect(investmentGroup: AppAutoCompleteModel) {
    this.investmentGroupSelected = investmentGroup.label;
    this.investmentGroupsComplete = this.investmentGroupsComplete.filter(group => group.id === investmentGroup.value);
  }

  onSearchUserSelected(userSelected: AppAutoCompleteModel) {
    this.userSelected = userSelected.label;
    this.users.data = this.users.data.filter(user => user.id === userSelected.value);
  }

  onInvestmentGroupChange(investmentGroup: string) {
    if (investmentGroup.length == 0) {
      this.investmentGroupsComplete = this.investmentGroups.data;
    }
  }

  onSearchUserChange(user: string) {
    if (user.length == 0) {
      this.usersComplete = this.users.data;
    }
  }

  setUserByAssociatedFound(founds) {
    return founds
      .filter(group => group.associated == true)
      .map(({ users = [], name }) => {
        users.forEach(element => {
          element.group = name;
        });

        return users || [{ name: '' }];
      })
      .reduce((a: any, b: any) => [...a, ...b], [])
      .map((user: any, i: any, arr) => {
        if (user && user.id) {
          user.qtd = arr.filter(e => e.id === user.id).length;
          if (user.qtd > 1) user.group = user.group + ', + ' + (user.qtd - 1);
        }
        return user;
      })
      .filter((v, i, a) => a.findIndex(t => t.id === v.id && t.name) === i);
  }

  async getFunds() {
    const payload = `{"code": "${this.code}"}`;

    const result = await this.associarFundosService.getFund(payload);
    const { investmentGroups } = result;

    this.setGroups(investmentGroups);

    this.fund = {
      code: this.code,
      name: this.name,
      investmentGroups: this.groups
        .filter(grp => grp.associated == true)
        .map(gp => ({ id: gp.id })),
    };

    this.users = new MatTableDataSource<any>(
      this.setUserByAssociatedFound(this.groups).sort((a, b) => {
        return a.name
          .toLowerCase()
          .normalize('NFD')
          .replace(/[^a-zA-Z0-9s]/g, '') >
          b.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[^a-zA-Z0-9s]/g, '')
          ? 1
          : -1;
      }),
    );

    this.users.sortingDataAccessor = (data, sortHeaderId) =>
      data[sortHeaderId]
        .normalize('NFD')
        .replace(/[^a-zA-Z0-9s]/g, '')
        .toLowerCase();

    this.users.sort = this.sortUsers;

    this.getInvestmentGroups();

    this.usersCompleteFiltred = this.users.filteredData.map(user => ({
      label: user.name,
      value: user.id
    }))

    this.investmentGroupsCompleteFiltred = this.investmentGroupsComplete.map(group => ({
      label: group.name,
      value: group.id
    }))
  }

  getInvestmentGroups() {
    this.investmentGroups = new MatTableDataSource<InvestmentGroups>(
      (this.groups as Array<any>).naturalSort(['name']),
    );

    this.investmentGroups.sortingDataAccessor = (data, header) =>
      data[header].naturalNormalize();
    
    this.investmentGroupsComplete = this.investmentGroups.data;
    
  }

  changeCheck({ id }) {
    const groupUpdated = this.groups.map(group => {
      if (group.id == id) {
        group.associated = !group.associated;
      }
      return group;
    });
    this.setGroups(groupUpdated);
    this.users.data = this.setUserByAssociatedFound(this.groups);
  }

  onSave() {
    let title,cancel,save:string
    title=this.translatorService.translateConfirmBox('titleSaveAssociation')
    cancel=this.translatorService.translateConfirmBox('cancelConfirm')
    save=this.translatorService.translateConfirmBox('saveAssociation')

    this.appDialog.confirmBox({
      lblTitle: title,
      lblSubtitle: '',
      lblCancelButton: cancel,
      lblConfirmButton: save,
      color: ConfirmBoxColor.error,
      onConfirm: () => {
        this.fund = {
          code: this.code,
          name: this.name,
          investmentGroups: this.groups
            .filter(grp => grp.associated == true)
            .map(gp => ({ id: gp.id })),
        };
        this.associarFundosService
          .setFund(this.fund)
          .pipe(take(1))
          .subscribe(() => this.dialogRef.close());
      },
    });
  }

  filterUsers(event: Event) {
    this.users.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    };
    this.usersFilter = (event.target as HTMLInputElement).value;
    this.users.filter = this.usersFilter;

    if (this.usersFilter.length > 0 && this.usersFilter.length % 2 == 0) {
      this.usersComplete = this.users.filteredData;
    } else if (this.usersFilter.length == 0) {
      this.usersComplete = [];
    }
  }
}
